import { render, staticRenderFns } from "./PortfolioItem.vue?vue&type=template&id=bd8c361c&scoped=true"
import script from "./PortfolioItem.vue?vue&type=script&lang=js"
export * from "./PortfolioItem.vue?vue&type=script&lang=js"
import style0 from "./PortfolioItem.vue?vue&type=style&index=0&id=bd8c361c&prod&lang=scss"
import style1 from "./PortfolioItem.vue?vue&type=style&index=1&id=bd8c361c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8c361c",
  null
  
)

export default component.exports